import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import { MICROCOPY_SIZE } from 'HubStyleTokens/sizes';
import { margin as m } from '../styles/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
const DescriptionList = styled.dl.withConfig({
  displayName: "UIDescriptionList__DescriptionList",
  componentId: "sc-1anwb28-0"
})(["", ";dt{font-size:", ";color:", ";line-height:1.5;}dd{", ";", ";}"], m('y', 0), MICROCOPY_SIZE, SLINKY, m('left', 0), m('bottom', 3));
const UIDescriptionList = _ref => {
  let props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DescriptionList, Object.assign({}, props));
};
UIDescriptionList.displayName = 'UIDescriptionList';
UIDescriptionList.propTypes = {
  children: PropTypes.node
};
export default UIDescriptionList;